





























































import Vue from 'vue'

import AppForm from '@/components/app/AppForm.vue'

export default Vue.extend({
  name: "applications-page",
  components: { AppForm },

  data() {
    return {
      applications: {
        items: [] as any[],
        schema: {}
      },
      newApplication: null,
      unregister: () => { null }
    }
  },

  computed: {
    _schema():any[] {
      return this.$store.state.schemas["applications"] || []
    }
  },

  watch: {
    _schema(schema) {
      this.$set(this.applications, "schema", schema)
    }
  },

  methods: {
    getItems() {
      this.unregister()
      this.unregister = this.$db.collection("applications")
      // .where("partners", "array-contains", this.$store.state.user.partners[0])
      .onSnapshot(snapshot => {
        if (snapshot.size) {
          const applications:any[] = []
          snapshot.forEach(doc => {
            applications.push({_id: doc.id, ...doc.data()})
          })
          this.applications.items = applications
        }
      })
    },
    newApplicationCreated(response) {
      this.newApplication = response.data
    }
  },

  filters: {
    
  },

  created() {
    const getItems = setInterval(() => {
      if (this.$store.state.user.partners) {
        this.getItems()
        clearInterval(getItems)
      }
    }, 50)
  },
  mounted() {

  },
  updated() {
    
  }
})
